import ModuleTextMedia from './ModuleTextMedia';

export default ModuleTextMedia;
export * from './ModuleTextMedia';
